export default __webpack_public_path__ + "static/media/login-background.96636a56.png";